import {envUtil} from './env';

export function genSystemDevice() {
  if (envUtil.isApp) {
    const device = window.navigator.userAgent.split(' ')[1];
    if (device === 'iOS') {
      return 'IOS';
    }
    if (device === 'Android') {
      return 'ANDROID';
    }
  }
  return 'WEB';
}

export function genSystemDeviceForHttp() {
  if (envUtil.isApp) {
    const device = window.navigator.userAgent.split(' ')[1];
    if (device === 'iOS') {
      return 'IOS-H5';
    }
    if (device === 'Android') {
      return 'ANDROID-H5';
    }
  }
  // if (envUtil.isMobile) {
  //   return 'H5';
  // }
  return 'WEB';
}
